export class ReporteError {

    public documento: string;
    public fechaError: Date;
    public mensaje: string;
    public fechaDocumento:  Date;
    public referencia1: string;
    public referencia2: string;
    public referencia3: string;
    public estado: string;
    
}